module.exports = __webpack_public_path__ + "img/f5ce50a.png";